import React, { useState, useEffect } from 'react';
import { View, Text, Pressable } from 'react-native';

import Autocomplete from 'app/src/components/Autocomplete';
import Input from 'app/src/elements/inputs';
import { Hint } from 'app/src/styles';

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const CustomLocation = (props) => {
  const {
    setShowCustomLocationFields, control, errors, register, setValue,
    asset
  } = props;
  return (
    <View
      style={{
        border: 'solid 1px black',
        borderRadius: '5px',
        padding: '10px'
      }}
    >
      <View
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between'
        }}
      >
        <Text style={{fontSize: '16px'}}>
          Custom Location:
        </Text>
        <Pressable
          onPress={() => setShowCustomLocationFields(false)}
        >
          <Text>use regular location</Text>
        </Pressable>
      </View>
      <Hint>Displays on Release</Hint>
      <br/>
      <Input.Text
        label="Street:"
        name="street"
        control={control}
      />
      <Input.Text
        label="City:"
        name="city"
        control={control}
      />
      <Input.StatePicker
        label="State:"
        name="state"
        control={control}
        errors={errors}
      />
      <Input.Text
        label="Zip:"
        name="postalCode"
        control={control}
      />
      <Input.Text
        label="Yard POC"
        name="releaseYardContact"
        hint="Displays on release. List name, email, phone # as desired."
        control={control}
        errors={errors}
      />
      <Input.Text
        label="Yard Email:"
        name="releaseYardEmail"
        hint="Release will be sent to this address, but will not display on release."
        control={control}
        errors={errors}
        id="releaseYardEmail"
        {...register("releaseYardEmail", {
          validate: {
            maxLength: (v) =>
              v.length <= 50 || "The email should have at most 50 characters",
            matchPattern: (v) => !v || EMAIL.test(v) ||
              "Email address must be a valid address",
          },
        })}
      />
      <Autocomplete
        label="ELAG POC"
        hint="Enter first name last name and select the name. Name, email, phone # display on release. Email & phone # pull from the system."
        placeHolder={asset?.equiplincContact?.fullName}
        resource="User"
        setValue={(name, value) => setValue('equiplincContactId', value)}
        name="equiplincContactId"
      />
    </View>
  )
}

export default CustomLocation;
